// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__16Im4","log":"ModalInventoryLogs_log__19VDT","date":"ModalInventoryLogs_date__20GmY","userName":"ModalInventoryLogs_userName__2txvk"};